import axios from './axiosInterceptors';
import authHeader from "./authentification-header";
import store from '../helpers/store';

const permissions = store.getState().privilegeManager.appliedPermissions;
const deniedMessage = "You don't have permission. If this is a mistake, please contact your administrator."

const API_URL = "/api/v1/transactions/";

const getPlanList = () => {
    return axios.post(API_URL + 'PlanList', { headers: authHeader() })
        .then((response) => {
           // console.log(response);
            return response;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const getTransactionsByTicketsIds = (ticketsIds) => {
    return axios.post(API_URL + 'by-tickets', ticketsIds, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const searchTransactions = (formData) => {
    return axios.post(API_URL + 'search', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch(function (error) {
            console.log("AXIOS ERROR: ", error);
            if (error.response) {
                return error.response.data;
            }
            return {};
            
        })
};
const searchTransactionsForExternalSale = (formData) => {
    return axios.post(API_URL + 'search-for-external-at-sale', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch(function (error) {
            console.log("AXIOS ERROR: ", error);
            if (error.response) {
                return error.response.data;
            }
            return {};

        })
};
const changeStatusByTicketsId = (formData) => {
    return axios.post(API_URL + 'change-status', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const changeStatusByTicketId = (formData) => {
    return axios.post(API_URL + 'change-status-ticket', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const saveAndChangeStatusByTicketId = (formData) => {
    return axios.post(API_URL + 'save-change-status', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const editTransaction = (formData) => {
    return axios.post(API_URL + 'edit', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const addEditTransactionWithItems = (formData) => {
    return axios.post(API_URL + 'add-edit-with-items', formData, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const deleteTransaction = (ticketId) => {
    return axios
        .delete(API_URL + "delete",
            { data: { ticketId: ticketId }}).then((response) => {
            return response.data;
        });
};

const allActions = {
    getTransactionsByTicketsIds,
    searchTransactions,
    searchTransactionsForExternalSale,
    editTransaction,
    addEditTransactionWithItems,
    deleteTransaction,
    changeStatusByTicketsId,
    changeStatusByTicketId,
    getPlanList
};

export default allActions;